<template>
 
  <!-- ErrorModal -->
  <div
    class="modal fade"
    id="errorModal"
    tabindex="-1"
    aria-labelledby="ErrorModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="ErrorModalLabel">
            Unable to Create New Agency
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="closeErrorModal"
          ></button>
        </div>
        <div class="modal-body">
          <label style="padding-bottom: 12px">
              Agency ID must be unique and SFTP UserName must be unique
          </label>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-success"
            style="width: 100%"
            data-bs-dismiss="modal"
            @click="addNewAgency"
          >
             OK
          </button>
        </div>
      </div>
    </div>
  </div> 


  <div
    class="modal fade"
    id="errorEditModal"
    tabindex="-1"
    aria-labelledby="ErrorEditModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="ErrorEditModalLabel">
            Unable to Edit Agency
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="closeErrorEditModal"
          ></button>
        </div>
        <div class="modal-body">
          <label style="padding-bottom: 12px">
               SFTP UserName must be unique
          </label>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-success"
            style="width: 100%"
            data-bs-dismiss="modal"
            @click="editAgency"
          >
             OK
          </button>
        </div>
      </div>
    </div>
  </div> 
</template>

<script setup lang="ts">
import GlobalData from "@/GlobalData";
import { ref, onMounted, watch  } from "vue";
import { useRouter } from "vue-router";
import { useAgencyStore } from "@/stores/agency";

const agencyStore = useAgencyStore();
const newWorkflow = ref("");
const error = ref<string | null>(null);

onMounted(() => {
  let editAgencyModal: any = document.getElementById(
    "editAgencyModal"
  );

  editAgencyModal.addEventListener("hidden.bs.modal", function () {
    GlobalData.getInstance().changeBackgroundPosition(
      "background-layout",
      "agency-list-item"
    );
  });
});

const addNewAgency = () => {
  agencyStore.openAddNewModal();
};

const editAgency = () => {
  agencyStore.openEditModal();
  GlobalData.getInstance().changeBackgroundPosition(
    "agency-list-item",
    "background-layout"
  );
};

const closeErrorModal = () => {
  agencyStore.closeErrorModal();
}

const closeErrorEditModal = () => {
  agencyStore.closeErrorEditModal();
}

</script>
